// src/coponent/Home.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import logoImg from '/home/masteraccounting/reactjs/src/asset/logoLight.png';

const pages = [
    { name: '我的勞報單', path: '' },
    { name: '新增勞報單', path: 'create' },
    /*{ name: '費用方案', path: 'pricing' },*/
    { name: '會計課程', path: 'courses', href: 'https://mastertalks.tw/collections/%E6%9C%83%E8%A8%88%E7%A8%85%E5%8B%99' },
    { name: '主控台', path: 'consoleuser' }
];
const settings = [
    { name: '我的帳號', path: 'myaccount' },
    { name: '重設密碼', path: 'passwordreset' },
    { name: '登出', path: 'logout' },
];

function Header() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);

    const [points, setPoints] = useState(false); 

    const [username, setUsername] = useState(false); 

    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false); // 默认未登录
    const [checkedLogin, setCheckedLogin] = useState(false); // 是否已检查过登录状态
    const [isAdmin, setIsAdmin] = useState(false); // 默认未登录

    useEffect(() => {
      // 发送请求到 http://masteraccounting.tw:3001/api/login
      fetch('https://macct.tw/api/login', {
        method: 'GET',
        credentials: 'include' // 保持与后端会话的状态
      })
      .then(response => response.json())
      .then(data => {
        // 根据返回的数据判断是否已登录
        setIsLoggedIn(data.isLoggedIn);
        setCheckedLogin(true); // 标记为已检查过登录状态
        setPoints(data.totalPoints);//寫入剩餘點數
        setUsername(data.username) //讀取email
        
        if(data.admin){
          setIsAdmin(true);
        }

        if(data.totalPoints < 1 && window.location.pathname === '/create'){
          alert("您的勞報餘額不足！");
          navigate('/');
        }
        console.log("isLoggedIn in first useEffect:", data.isLoggedIn);
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }, []);
  
    useEffect(() => {
      // 在Home.js渲染完成後，檢查是否已登入，若未登入，則導向Login.js
      console.log("isLoggedIn in second useEffect:", isLoggedIn);
      if (checkedLogin && !isLoggedIn) {
        navigate('/login'); // 導向Login.js
      }
    }, [checkedLogin, isLoggedIn, navigate]);
  
    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
  
    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };
  
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };
  
    return (
      <AppBar position="static">
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: 'none', md: 'flex' },
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              <img src={logoImg} alt="Logo" style={{ height: '2.5rem' }} />
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                }}
              >
                {pages.map((page) => (
                  <MenuItem key={page.path} onClick={handleCloseNavMenu}>
                    <Link to={page.href ? `${page.href}` : `/${page.path}`} target={page.href ? "_blank":"_self" } style={{ textDecoration: 'none', color: 'inherit' }}>
                        <Typography textAlign="center">{page.name}</Typography>
                    </Link>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              <img src={logoImg} alt="Logo" style={{ height: '2.5rem' }} />
            </Typography>
            <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
              {pages.map((page) => {
                  if(page.name == "console" && !isAdmin){
                    return "";
                  } 
                  return (
                  <Link to={page.href ? `${page.href}` : `/${page.path}`} target={page.href ? "_blank":"_self" } style={{ textDecoration: 'none', color: 'inherit' }}>
                      <Button
                        key={page.path}
                        onClick={handleCloseNavMenu}
                        sx={{ my: 2, color: 'white', display: 'block' }}
                      >
                      {page.name}
                      </Button>
                  </Link>
                  )
                }
              )}
            </Box>
            <Typography variant="h6" sx={{ mr: 1 }}>
                  剩餘點數：{points}張
              </Typography>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {settings.map((setting) => {
                  const isReset = setting.path === 'passwordreset';//重設密碼連結加上參數
                  const getDateTime = () => { //建立重設密碼的時間
                    const pad = (n) => String(n).padStart(2, '0');
                    const now = new Date();
                    const yyyy = now.getFullYear();
                    const MM = pad(now.getMonth() + 1);
                    const dd = pad(now.getDate());
                    const HH = pad(now.getHours());
                    const mm = pad(now.getMinutes());
                    const ss = pad(now.getSeconds());
                    return `${yyyy}-${MM}-${dd} ${HH}:${mm}:${ss}`;
                  };

                  const to = isReset
                    ? `/passwordreset?auth=${encodeURIComponent(username || '')}&datetime=${encodeURIComponent(getDateTime())}`
                    : `/${setting.path}`;

                  return (
                    <MenuItem key={setting.path} onClick={handleCloseUserMenu}>
                      <Link to={to} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <Typography textAlign="center">{setting.name}</Typography>
                      </Link>
                    </MenuItem>
                  );
                })}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    );
  }
export default Header;

